export { supportsPassiveEvents } from 'detect-it';